import React, { useEffect, useRef } from 'react'
import { getHtmlDataType, HTML_TYPE, SvgNewTab } from '@ui-kit'
import { DocumentPopoutPropsType } from '../../types/workflow.types'
import { STRINGS } from '../../utils/strings'
import { SIGNED_URL_REFETCH_TIMEOUT } from '../../utils/constants'

const startSignedUrlRefetchTimer = (fetchNewUrl: { current: boolean }) =>
  setTimeout(() => {
    fetchNewUrl.current = true
  }, SIGNED_URL_REFETCH_TIMEOUT)

const DocumentPopout: React.FC<DocumentPopoutPropsType> = ({
  source,
  generateUrl,
  className,
}) => {
  const fetchNewUrl = useRef(false)
  const timerId = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleClick = async () => {
    const sourceType = getHtmlDataType(source)
    const isBase64 = sourceType === HTML_TYPE.BASE64_PDF

    let sourceUrl = source
    if (isBase64) {
      const response = await fetch(`data:application/pdf;base64,${source}`)
      const blob = await response.blob()
      sourceUrl = URL.createObjectURL(blob)
    } else if (generateUrl && fetchNewUrl.current) {
      sourceUrl = (await generateUrl()) || source
      fetchNewUrl.current = false
      timerId.current = startSignedUrlRefetchTimer(fetchNewUrl)
    }

    window.open(sourceUrl, '_blank', 'noopener,noreferrer')
  }

  useEffect(() => {
    timerId.current = startSignedUrlRefetchTimer(fetchNewUrl)
    return () => {
      if (timerId.current) clearTimeout(timerId.current)
    }
  }, [])

  return (
    <button
      className={`cursor-pointer inline-flex items-center ${className}`}
      onClick={handleClick}
      title={STRINGS.OPEN_DOC_IN_NEW_TAB}
      aria-label={STRINGS.OPEN_DOC_IN_NEW_TAB}
      type="button"
    >
      <SvgNewTab width={16} height={16} />
    </button>
  )
}

export default DocumentPopout
